import React, { useEffect,useContext } from 'react'
import { useDispatch } from 'react-redux';
import { Box, IconButton, Switch, Typography, Chip } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { DataGrid } from '@mui/x-data-grid';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import { useNavigate } from 'react-router-dom';
import { Edit, Delete } from '@mui/icons-material';
import { formatDateTime } from '../../../../utils/dateUtils';
import NoRowsLayout from '../../../../components/Layout/NoRowsLayout';
import useResponsive from '../../../../hooks/useResponsive';
import { ItemContext } from './SectionItems';
import Loading from '../../../../components/Loader/Loading';


const actionTypeColors = {
    navigate: { bg: '#e3f2fd', color: '#1565c0' },
    open_service: { bg: '#f3e5f5', color: '#7b1fa2' },
    open_category: { bg: '#e8f5e9', color: '#2e7d32' },
    open_url: { bg: '#fff3e0', color: '#e65100' },
    show_popup: { bg: '#fce4ec', color: '#c2185b' },
    none: { bg: '#f5f5f5', color: '#757575' }
};
const SectionItemList = () => {
  const menuDispatch = useDispatch();
  useEffect(() => {
      menuDispatch({
          type: 'menuSelect',
          payload: 'home-screen'
      });
  }, []);
  const { isSm } = useResponsive();
    const navigate = useNavigate();
    const {
        list,
        loading,
        allRowCount,
        paginationModel,
        handlePaginationChange,
        handleSortingChange,
        sortModel,
        handleStatusChange,
        handleDeleteItem,
        sectionId
    } = useContext(ItemContext);

    const columns = [
        // {
        //     field: 'thumbnail',
        //     headerName: 'Thumbnail',
        //     headerAlign: 'center',
        //     flex: 0.8,
        //     sortable: false,
        //     renderCell: (params) => (
        //         <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        //             {params.row.thumbnailUrl ? (
        //                 <Box
        //                     component="img"
        //                     src={`${process.env.REACT_APP_IMAGE_STORE_PATH}/${params.row.thumbnailUrl}`}
        //                     alt={params.row.title}
        //                     sx={{
        //                         width: 40,
        //                         height: 40,
        //                         objectFit: 'cover',
        //                         borderRadius: 1
        //                     }}
        //                 />
        //             ) : params.row.imageUrl ? (
        //                 <Box
        //                     component="img"
        //                     src={`${process.env.REACT_APP_IMAGE_STORE_PATH}/${params.row.imageUrl}`}
        //                     alt={params.row.title}
        //                     sx={{
        //                         width: 40,
        //                         height: 40,
        //                         objectFit: 'cover',
        //                         borderRadius: 1
        //                     }}
        //                 />
        //             ) : (
        //                 <Box
        //                     sx={{
        //                         width: 40,
        //                         height: 40,
        //                         backgroundColor: '#f5f5f5',
        //                         borderRadius: 1,
        //                         display: 'flex',
        //                         alignItems: 'center',
        //                         justifyContent: 'center'
        //                     }}
        //                 >
        //                     <Typography sx={{ fontSize: '0.6rem', color: '#999' }}>N/A</Typography>
        //                 </Box>
        //             )}
        //         </Box>
        //     )
        // },
        // {
        //     field: 'position',
        //     headerName: 'Position',
        //     headerAlign: 'center',
        //     flex: 0.5,
        //     sortable: true,
        //     renderCell: (params) => (
        //         <Box sx={{
        //             backgroundColor: 'primary.main',
        //             color: 'white',
        //             borderRadius: '50%',
        //             width: 28,
        //             height: 28,
        //             display: 'flex',
        //             alignItems: 'center',
        //             justifyContent: 'center',
        //             fontSize: '0.75rem',
        //             fontWeight: 'bold'
        //         }}>
        //             {params.row.position || '-'}
        //         </Box>
        //     )
        // },
        {
            field: 'title',
            headerName: 'Title',
            headerAlign: 'center',
            flex: 1.2,
            sortable: true,
            renderCell: (params) => (
                <Box sx={{ width: '100%' }}>
                    <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
                        {params.row.title || 'N/A'}
                    </Typography>
                    {params.row.subtitle && (
                        <Typography sx={{ fontSize: '0.65rem', color: '#666' }}>
                            {params.row.subtitle}
                        </Typography>
                    )}
                </Box>
            )
        },
        {
            field: 'actionType',
            headerName: 'Action Type',
            headerAlign: 'center',
            flex: 0.9,
            sortable: true,
            renderCell: (params) => {
                const type = params.row.actionType;
                const colors = actionTypeColors[type] || { bg: '#f5f5f5', color: '#757575' };
                return (
                    <Chip
                        label={type?.replace(/_/g, ' ') || 'N/A'}
                        size="small"
                        sx={{
                            backgroundColor: colors.bg,
                            color: colors.color,
                            fontSize: '0.6rem',
                            textTransform: 'capitalize',
                            fontWeight: 500
                        }}
                    />
                );
            }
        },
        {
            field: 'section',
            headerName: 'Section',
            headerAlign: 'center',
            flex: 0.8,
            sortable: false,
            renderCell: (params) => (
                <Typography sx={{ fontSize: '0.75rem' }}>
                    {params.row.section.title || 'N/A'}
                </Typography>
            )
        },
        {
            field: 'status',
            headerName: 'Status',
            headerAlign: 'center',
            flex: 0.6,
            sortable: false,
            renderCell: (params) => (
                <PermissionGuard feature='customer-app' permission='canEdit'>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'center', width: '100%' }}>
                        <Switch
                            size='small'
                            checked={params.row.isActive}
                            onChange={() => handleStatusChange({ isActive: !params.row.isActive }, params.row.id)}
                            sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': { color: 'success.main' },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: 'success.main' },
                                '& .MuiSwitch-switchBase': { color: 'error.main' },
                                '& .MuiSwitch-track': { backgroundColor: 'error.main' }
                            }}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                        <Typography
                            sx={{
                                color: params.row.isActive ? 'success.main' : 'error.main',
                                fontWeight: '600',
                                fontSize: '0.6rem'
                            }}
                        >
                            {params.row.isActive ? 'Active' : 'Inactive'}
                        </Typography>
                    </Box>
                </PermissionGuard>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Created On',
            headerAlign: 'center',
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <Typography sx={{ fontSize: '0.65rem' }}>
                    {params.row.createdAt ? formatDateTime(params.row.createdAt) : ''}
                </Typography>
            )
        },
        {
            field: 'actions',
            headerName: 'Actions',
            headerAlign: 'center',
            flex: 0.8,
            sortable: false,
            renderCell: (params) => (
                <Box sx={{ p: 1, display: 'flex', gap: 0.5, justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <IconButton
                        sx={{ color: "blue" }}
                        onClick={() => navigate(`/customer-app/home-screen/section-item/view/${params.row.id}`)}
                        size="small"
                    >
                        <RemoveRedEyeIcon sx={{ fontSize: '0.95rem' }} />
                    </IconButton>
                    <PermissionGuard feature='customer-app' permission='canEdit'>
                        <IconButton
                            onClick={() => navigate(`/customer-app/home-screen/section-item/${params.row.id}`)}
                            size="small"
                            color='warning'
                        >
                            <Edit sx={{ fontSize: '0.95rem' }} />
                        </IconButton>
                    </PermissionGuard>
                    <PermissionGuard feature='customer-app' permission='canDelete'>
                        <IconButton
                            onClick={() => handleDeleteItem(params.row.id)}
                            size="small"
                            color='error'
                        >
                            <Delete sx={{ fontSize: '0.95rem' }} />
                        </IconButton>
                    </PermissionGuard>
                </Box>
            )
        }
    ];

  return (
    <Box sx={{ overflow: "auto" }}>
            <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
                <DataGrid
                    rows={list}
                    columns={columns.map((col) => ({
                        ...col,
                        minWidth: isSm && (col.minWidth || 150)
                    }))}
                    getRowId={(row) => row.id}
                    rowCount={allRowCount}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={handlePaginationChange}
                    sortingMode="server"
                    sortModel={sortModel}
                    onSortModelChange={handleSortingChange}
                    disableMultiSort={true}
                    loading={loading}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    slots={{
                        loadingOverlay: Loading,
                        noRowsOverlay: NoRowsLayout,
                    }}
                    autoHeight
                    getRowHeight={() => 'auto'}
                    sx={{
                        '& .MuiDataGrid-cell': {
                            border: 1,
                            borderRight: 0,
                            borderTop: 0,
                            borderColor: 'lightgrey',
                            display: 'flex',
                            alignItems: 'center',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            borderBottom: '2px solid rgba(224, 224, 224, 1)',
                            borderTop: '2px solid rgba(224, 224, 224, 1)',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            p: 0,
                            height: 'fit-content',
                            minHeight: '0 !important',
                            height: '2rem'
                        },
                        '& .MuiDataGrid-columnHeader': {
                            borderLeft: '1px solid rgba(224, 224, 224, 1)',
                            '&:last-child': { borderRight: 'none' },
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 600,
                            color: '#3e3e3e'
                        },
                        '& .MuiDataGrid-row': {
                            '&:last-child .MuiDataGrid-cell': {
                                borderBottom: '1px solid rgba(224, 224, 224, 1)',
                            },
                            '& .MuiDataGrid-cell:last-child': {
                                borderRight: 'none',
                            },
                        },
                        '& .MuiDataGrid-columnSeparator': { display: 'none' },
                    }}
                />
            </Box>
        </Box>
  )
}

export default SectionItemList
